import React, { useState } from 'react';
import Stepper from '../../component/Stepper/Stepper';
import AppHeader from '../../component/AppHeader/app-header';
import PricingSection from './components/PricingSection';

const SubscriptionPlan = () => {
	const steps = [{ label: 'Select Plan' }, { label: 'Billing Details' }, { label: 'Make Payment' }];

	const [billing, setBilling] = useState('monthly');

	const plans = [
		{
			title: 'Starter Plan',
			description: 'Best for Startups & small businesses just getting started',
			monthlyPrice: 10,
			yearlyPrice: 5,
			showYearlyDiscount: true,
			features: [
				'Create up to 50 sales orders & invoices / month',
				'Generate 20 purchase orders & bills / month',
				'1 User, 1 Warehouse, 1 GSTIN',
				'Basic inventory & order tracking',
				'Simple sales & purchase reports',
				'Access from web & mobile app',
				'Secure cloud backup included',
				'Import/export limited data (CSV/Excel)',
				'Trial access to premium features (for 7 days)',
				'Email support for setup & queries',
			],
			cta: 'Get Started',
		},
		{
			title: 'Professional Plan',
			description: 'Perfect for Growing businesses needing automation & integrations',
			monthlyPrice: 5,
			yearlyPrice: 10,
			features: [
				'Manage 5000 orders & invoices / month',
				'Handle 2500 purchase orders & bills / month',
				'2 Users, 2 Warehouses, 1 GSTIN',
				'Automated workflows & price lists',
				'Custom fields, templates & reporting dashboards',
				'Integration with shipping partners & payment gateways',
				'Low-stock alerts & email notifications',
				'Import/export bulk data (Excel, CSV)',
				'Role-based access & user permissions',
				'Priority email support',
			],
			cta: 'Go Professional',
			highlighted: true,
		},
		{
			title: 'Enterprise Plan',
			description: 'Best for Enterprises with high volume & advanced needs',
			custom: true,
			features: [
				'Manage 10,000+ orders & invoices / month',
				'Handle 5000+ purchase orders & bills / month',
				'4 Users, 4 Warehouses, 3 GSTINs',
				'Advanced automation & scheduling tools',
				'Multi-currency & advanced tax compliance support',
				'Integrations with ecommerce, CRM & accounting platforms',
				'Customizable portals & document templates',
				'Detailed analytics, forecasting & audit logs',
				'5M+ record storage with data security',
				'Premium support (phone + email)',
			],
			cta: 'Learn More',
		},
	];

	return (
		<main className="main-wrapper h-100">
			<AppHeader
				title="Subscription Plan"
				username={'Sanjay Choudhary'}
			/>
			<div className="py-4">
				<Stepper
					steps={steps}
					currentStep={1}
				/>
				<PricingSection
					billing={billing}
					setBilling={setBilling}
					plans={plans}
				/>
			</div>
		</main>
	);
};

export default SubscriptionPlan;
